import DataGrid, { Column, Item, LoadPanel, Paging, Scrolling, SearchPanel, Toolbar } from 'devextreme-react/data-grid';
import { useGetPostInstall } from '../api/get-post-install';
import CallScriptComp from '../../call-script/component/CallScriptComp';
import { Link } from 'react-router-dom';
import { ScriptFileType } from '../../../../types/enums';
import { useContext } from 'react';
import { RetailOrderContext } from '../context/RetailOrderContext';

export default function RetailOrderPostInstallGrid() {
	const orders = useGetPostInstall();

	return (
		<>
			{
				orders.data?.length > 0 ?
					<DataGrid
						className={'dx-card wide-card store-notes-grid'}
						dataSource={orders.data}
						allowColumnReordering={true}
						allowColumnResizing={true}
						showBorders={true}
						showColumnLines={true}
						columnAutoWidth={true}
						keyExpr={'retailOrderID'}
						height="68vh"
					>
						<LoadPanel enabled={false} />
						<Paging enabled={false}></Paging>
						<Scrolling rowRenderingMode='virtual'></Scrolling>
						<SearchPanel visible={true} />

						<Toolbar visible={orders.data?.length > 0}>
							<Item location='before' name='searchPanel'>
							</Item>
							<Item location='after'>
							</Item>
						</Toolbar>

						<Column
							dataField={'roNumber'}
							caption={'Order #'}
							dataType="string"
							cellRender={(cell: any) => {
								return <Link to={`/cfi/retail-order/${cell.data.retailOrderID}/`}>
									{cell.data.roNumber}
								</Link>;
							}}
						/>
						<Column
							dataField={'customerName'}
							caption={'Customer Name'}
							dataType="string"
						/>
						<Column
							dataField={'installer'}
							caption={'Installer'}
							dataType="string"
						/>
						<Column
							dataField={'actualInstallDate'}
							caption={'Actual Install Date'}
							dataType="datetime"
						/>
						<Column
							dataField={'dealerNumber'}
							caption={'Store #'}
							dataType="string"
						/>
						<Column
							dataField={'lastNote'}
							caption={'Last Retail Order Note'}
							dataType="string"
							cssClass={'multi-line'}
						/>
						<Column
							width={200}
							cellRender={(row: any) => {
								return <>
									<CallScriptComp
										retailOrderID={row.data.retailOrderID}
										retailOrderNumber={row.data.roNumber}
										fileType={ScriptFileType.PostInstall}
										fileName={"Post Install"}
										isCheckBoxNeeded={false}
										submitCallback={() => orders.refetch()}
										fileAttachment={null}
									/>
								</>;
							}}
						/>
					</DataGrid>
					:
					<div>
						{!orders.isLoading && 'There are no more orders to read at the moment.'}
					</div>
			}
		</>
	)
}
